var shipping = new Array();
shipping['uk_1st'] = new Array();
shipping['uk_nd'] = new Array();
shipping['uk_nds'] = new Array();
shipping['us'] = new Array();
shipping['eur'] = new Array();
shipping['eur_non'] = new Array();
shipping['rest'] = new Array();
shipping['free'] = new Array();

   jQuery(document).ready(function() {
		document.getElementById('shipping_country').selectedIndex = 0;
		document.getElementById('shipping_uktype').selectedIndex = 0;
		document.getElementById('shipping_country').disabled = false;
		document.getElementById('shipping_uktype').disabled = false;
   })

function DoShippingChange(objSelect, intWeight, intPrice) {
	if (objSelect.value == '') {
		document.getElementById("shipping_display").innerHTML = "-";
		return;
	}

	if (objSelect.value == 'uk') {
		document.getElementById('shipping_uktype_holder').style.display = 'block';
		document.getElementById('shipping_uktype').selectedIndex = 0;
		document.getElementById("shipping_display").innerHTML = "-";
	}
	else {
		document.getElementById('shipping_uktype_holder').style.display = 'none';

		if (shipping['free'][objSelect.value] != null) {
			if (intPrice > shipping['free'][objSelect.value]) {
				document.getElementById("shipping_display").innerHTML = 'FREE';
				return;
			}
		}

		var shippingcost = shipping[objSelect.value][0];
		for (var i in shipping[objSelect.value]) {
			if (i > intWeight)
				break;

			shippingcost = shipping[objSelect.value][i];
		}
		document.getElementById("shipping_display").innerHTML = GetPrice(shippingcost);
	}
}
function DoUKShippingChange(objSelect, intWeight, intPrice) {

	if (objSelect.value == 'uk_1st' && shipping['free']['uk'] != null) {
		if (intPrice > shipping['free']['uk']) {
			document.getElementById("shipping_display").innerHTML = 'FREE';
			return;
		}
	}

	var shippingcost = shipping[objSelect.value][0];
	for (var i in shipping[objSelect.value]) {
		if (i > intWeight)
			break;

		shippingcost = shipping[objSelect.value][i];
	}
	document.getElementById("shipping_display").innerHTML = GetPrice(shippingcost);

}
